import React from 'react';

import Box from 'components/elements/Box';
import { ReactComponent as IconPlus } from 'icons/icon-plus.svg';
import { ReactComponent as IconClose } from 'icons/icon-close.svg';
import { ReactComponent as IconCheck } from 'icons/icon-checkmark.svg';
import { useHover } from 'react-use';

import { format } from 'date-fns';
import {
  CustomListTitle,
  CustomListLastupdated,
  ListItemBox,
  CheckButton,
  DisabledCheckButton,
} from './styles';
import modularScale from 'styles/helpers/modular-scale';
import { ICustomList } from './shared';

interface ICustomListListItemProps {
  customList: ICustomList;
  entityIsInList: boolean;
  onAddClick: () => void;
  onDeleteClick: () => void;
}

const CustomListListItem: React.FC<ICustomListListItemProps> = (props) => {
  const { customList, onAddClick, onDeleteClick, entityIsInList } = props;
  const hasOneEntity = customList.entities?.length === 1;

  const DeleteButton = (hovered: boolean): React.ReactElement => (
    <CheckButton
      variant="secondary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={2}
      onClick={onLocalDeleteClick}
      py={2}
    >
      {hovered ? (
        <IconClose />
      ) : (
        <IconCheck data-pw="custom-lists-add-to-list-list-item-add-btn-disabled" />
      )}
    </CheckButton>
  );

  const onLocalDeleteClick = (): void => {
    onDeleteClick();
  };

  const [HoverableDeleteButton] = useHover(DeleteButton);

  const lastUpdated = customList.lastUpdatedAt
    ? new Date(customList.lastUpdatedAt)
    : new Date();

  const onLocalAddClick = (): void => {
    onAddClick();
  };

  return (
    <ListItemBox data-pw="custom-lists-add-to-list-list-item">
      <Box>
        {!entityIsInList && (
          <CheckButton
            variant="secondary"
            display="flex"
            alignItems="center"
            justifyContent="center"
            onClick={onLocalAddClick}
            px={2}
            py={2}
            data-pw="custom-lists-add-to-list-list-item-add-btn"
          >
            <IconPlus />
          </CheckButton>
        )}
        {entityIsInList && hasOneEntity && (
          <DisabledCheckButton
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="greys.6"
            fontSize="1"
            px={2}
            py={2}
            data-pw="custom-lists-add-to-list-list-item-add-btn-disabled"
          >
            <IconCheck />
          </DisabledCheckButton>
        )}
        {entityIsInList && !hasOneEntity && <>{HoverableDeleteButton}</>}
      </Box>
      <Box display="flex" flexDirection="column" marginLeft={modularScale(1)}>
        <CustomListTitle>{customList.displayName}</CustomListTitle>
        <CustomListLastupdated>{`Last updated ${format(
          lastUpdated,
          'PPP'
        )}`}</CustomListLastupdated>
      </Box>
    </ListItemBox>
  );
};

export default CustomListListItem;
